import { request } from "../../utils/request";

interface ApiRes<T> {
  code: number;
  data: T;
  msg: string;
}

/** 字幕翻译 - 文本模式 */
export const postSubtitleTranslateTextApi = (body: {
  sourceLanguage: string;
  targetLanguage: string;
  text: string;
}) =>
  request<ApiRes<{
    taskId: string;
    sourceLanguage: string;
    targetLanguage: string;
    translatedText: string;
    status: string;
    message: string;
    srt_text: string | null;
  }>>("/video/subtitle-translate/text", {
    method: "POST",
    body,
  });

/** 字幕翻译 - 上传 SRT 文件 */
export const postSubtitleTranslateSrtApi = (params: {
  sourceLanguage: string;
  targetLanguage: string;
  file: File;
}) => {
  const formData = new FormData();
  formData.append("file", params.file);
  return request<ApiRes<{
    taskId: string;
    status: string;
    message: string;
  }>>("/video/subtitle-translate/srt", {
    method: "POST",
    params: {
      sourceLanguage: params.sourceLanguage,
      targetLanguage: params.targetLanguage,
    },
    body: formData,
  });
};

/** 查询 SRT 字幕翻译任务状态 */
export const getSubtitleTranslateDownloadApi = (taskId: string) =>
  request<ApiRes<{
    taskId: string;
    status: string;
    message: string;
    progress: number;
    downloadUrl: string | null;
    error: string | null;
    srt_text: string | null;
  }>>("/video/subtitle-translate/download", {
    method: "GET",
    params: { taskId },
  });
